import styled from '@emotion/styled';

export const Subtitle = styled.p`
  font-size: 28px;
  font-family: ff-good-web-pro-condensed, sans-serif;
  font-weight: 700;
  display: block;
  text-align: center;
  color: ${(props) => props.color};
`;
